import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Hl7PatientList from './Hl7PatientList';
import Hl7PatientDetails from './Hl7PatientDetails';
import Hl7PatientAdd from './Hl7PatientAdd';

const Hl7Patients = () => (
  <Routes>
    <Route index element={<Hl7PatientList />} />
    <Route path="add" element={<Hl7PatientAdd />} />
    <Route path=":hl7PatientId" element={<Hl7PatientDetails />} />
  </Routes>
);

export default Hl7Patients;
